// extracted by mini-css-extract-plugin
export var companyName = "workUnitOverview-module--companyName--Xplz0";
export var container = "workUnitOverview-module--container--6oCIl";
export var containerHorizontal = "workUnitOverview-module--containerHorizontal--ol5Yl";
export var image = "workUnitOverview-module--image--PfuMu";
export var imageHorizontal = "workUnitOverview-module--imageHorizontal--zbqm0";
export var mb0 = "workUnitOverview-module--mb0--HTWy+";
export var textContainer = "workUnitOverview-module--textContainer--CUw80";
export var textContainerHorizontal = "workUnitOverview-module--textContainerHorizontal--QPKsL";